// React core imports
import React, { useState } from 'react';
import { useEffect } from 'react';

// React Router for navigation
import { Link } from 'react-router-dom';

// Bootstrap button component
import { Button } from 'react-bootstrap';

// Icons
import { LuFilter } from 'react-icons/lu'; // Filter icon
import { GrAttachment, GrInbox } from "react-icons/gr"; // Attachment and inbox icons
import { FaTruck } from 'react-icons/fa'; // Truck icon for shipping
import { IoSettingsOutline } from "react-icons/io5"; // Settings (gear) icon
import { AiOutlineFileAdd } from "react-icons/ai"; // Icon to add files
import { BsPencilFill } from "react-icons/bs"; // Pencil icon for editing
import { BsFileEarmarkCode } from "react-icons/bs"; // Icon for file/code (invoicing etc.)

// Filter modal component
// import Filter from '../../screens/cases/Filter.js';

// Axios for API calls
import axios from "axios";
import Header from '../../../header/header';
import Navvbar from '../../../header/Navvbar';


const CreatShipment = () => {

  // State to store all cases fetched from the API
  const [cases, setCases] = useState([]);

  // Controls visibility of settings dropdown per case
  const [dropdownVisible, setDropdownVisible] = useState(null);

  // Store current month and year (used for filtering)
  const [currentMonth, ] = useState(new Date().getMonth());
  const [currentYear, ] = useState(new Date().getFullYear());

  // Modal visibility state for filters
  const [show, setShow] = useState(false);

  // Stores IDs of selected cases
  const [selectedCases, setSelectedCases] = useState([]);

  // Modal for shipping (unused here, only setter is declared)
  const [, setShowModal] = useState(false);

  // Filter cases by current month and year
  const filteredCases = cases.filter((caseItem) => {
    const caseDate = new Date(caseItem.date); // Convert case date to Date object
    return caseDate.getMonth() === currentMonth && caseDate.getFullYear() === currentYear;
  });

  // Fetch cases using fetch API (initial call)
  useEffect(() => {
    const fetchCases = async () => {
      try {
        const res = await fetch("https://hms.backend.hiragroupcloud.com/api/cases");
        const data = await res.json();
        
        setCases(data);
      } catch (error) {
        console.error("Error fetching cases:", error);
      }
    };

    fetchCases();
  }, []);

  // Clean up modal element if it exists (on unmount)
  useEffect(() => {
    return () => {
      const modal = document.getElementById("modal");
      if (modal) {
        modal.remove();
      }
    };
  }, []);

  // Fetch cases again using axios (duplicate but potentially for fallback or testing)
  useEffect(() => {
    const fetchCases = async () => {
      try {
        const response = await axios.get("https://hms.backend.hiragroupcloud.com/api/cases");
        setCases(response.data);
      } catch (error) {
        console.error("Error fetching cases:", error);
      }
    };

    fetchCases();
  }, []);

  // Toggle dropdown for a specific case
  const toggleDropdown = (caseId) => {
    setDropdownVisible(dropdownVisible === caseId ? null : caseId);
  };

  // Handle individual case selection
  const handleSelectCase = (caseId) => {
    setSelectedCases((prevSelected) =>
      prevSelected.includes(caseId)
        ? prevSelected.filter((id) => id !== caseId)
        : [...prevSelected, caseId]
    );
  };

  // Handle select/deselect all cases
  const handleSelectAll = () => {
    setSelectedCases(
      selectedCases.length === cases.length ? [] : cases.map((caseItem) => caseItem._id)
    );
  };

  // Show the filter modal
  const handleShowModal = () => {
    setShow(true);
  };

  // Close the filter modal
  const handleCloseModal = () => {
    setShow(false);
  };

  // State for filter form fields
  const [filters, setFilters] = useState({
    caseNumber: '',
    invoiceNumber: '',
    accountNumber: '',
    provider: '',
    patientAppointment: '',
    labShip: '',
    deliveryDate: '',
    accountShip: '',
  });

  // State for selected shipper dropdown
  const [selectedShiper, setSelectedShiper] = useState("");
  const [selectedShipper, ] = useState(''); // Unused

  // Handle change in case number filter
  const handleCasesChange = (e) => {
    setFilters(prevFilters => ({ ...prevFilters, caseNumber: e.target.value }));
  };

  // Handle change in selected shipper
  const handleShiperChange = (e) => {
    setSelectedShiper(e.target.value);
  };

  // Apply filter and close modal
  const handleApply = () => {
   
    handleCloseModal();
  };

  // Style object for label elements
  const labelStyle = {
    fontWeight: 'bold',
    backgroundColor: '#e0e0e0',
    padding: '5px 10px',
    color: 'Black',
    textAlign: 'center',
    maxWidth: '600px',
    borderRadius: '7px 0 0 7px',
    height: '38px'
  };

  return (
    <>
      <Header />
      <Navvbar/>
      <div  style={{ width: '95%',  margin: '0 auto' ,padding:"20px" }}>
       {/* Header section with title and action buttons */}
<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
  {/* Page title */}
  <h2 className="title" style={{ margin: 0, backgroundColor: "white" }}>
    Cases To Create Shipment (£ 0.00)
  </h2>

  {/* Right side action buttons */}
  <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
    
    {/* Create Shipment Button - disabled if no cases selected */}
    <Button 
      style={{ backgroundColor: selectedCases.length > 0 ? '#004aad' : '#ccc', borderColor: "#ccc" }}
      disabled={selectedCases.length === 0}
      onClick={() => setShowModal(true)}
    >
      <FaTruck /> Create Shipment ({selectedCases.length})
    </Button>

    {/* Filter Button */}
    <div className="col-md-0 d-flex justify-content-end">
      <button
        style={{
          padding: '5px',
          backgroundColor: '#004aad',
          color: 'white',
          width: '90px',
          height: '35px',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}
        onClick={handleShowModal}
      >
        <LuFilter /> Filters
      </button>
    </div>
  </div>
</div>

{/* Filter dropdowns row: Case type and Shipper */}
<div style={{ display: 'flex' }}>

  {/* Case type filter */}
  <div style={{
    display: 'flex',
    alignItems: 'center',
    padding: '5px 15px',
    borderRadius: '5px',
    flex: 1,
    marginLeft: '-1%'
  }}>
    <label style={labelStyle}>Cases</label>
    <select
      style={{ width: '60%', borderRadius: '0 7px 7px 0' }}
      className="form-control"
      onChange={handleCasesChange}
      value={filters.caseNumber}
    >
      <option value="Open & closed case">Open & closed case</option>
      <option value="Closed cases">Closed cases</option>
      <option value="Open & closed case using selected service">Open & closed case using selected service</option>
      <option value="Closed case using selected service">Closed case using selected service</option>
    </select>
  </div>

  {/* Shipper selection - only active if cases are selected */}
  <div style={{
    display: 'flex',
    alignItems: 'center',
    padding: '5px 15px',
    borderRadius: '5px',
    flex: 1
  }}>
    <label style={labelStyle}>Shiper</label>
    <select
      style={{
        width: '60%',
        borderRadius: '0 7px 7px 0',
        backgroundColor: selectedCases.length === 0 ? '#f0f0f0' : '#ffffff',
        cursor: selectedCases.length === 0 ? 'not-allowed' : 'pointer'
      }}
      className="form-control"
      onChange={handleShiperChange}
      value={selectedShiper}
      disabled={selectedCases.length === 0}
    >
      <option value="">Select Service</option>
      <option value="Royal Mail">Royal Mail</option>
      <option value="UPS COURIER">UPS COURIER</option>
    </select>
  </div>
</div>

{/* Instructional note */}
<p style={{ fontSize: "14px" }}>
  * Select the cases first to show the default shipper
</p>


       {/* ✅ Cases Table */}
<table style={{ width: "100%", borderCollapse: "collapse" }}>
  <thead>
    <tr>
      {/* Master checkbox to select/deselect all cases */}
      <th>
        <input
          type="checkbox"
          checked={selectedCases.length === cases.length && cases.length > 0}
          onChange={handleSelectAll}
        />
      </th>

      {/* Table headers with icons for Inbox and Attachment */}
      {[
        "Inbox", "Attachment", "Case/Pan", "Invoice", "Account",
        "Provider", "Patient/Appt", "Lab Ship", "Account Ship", "Delivery Date"
      ].map((header) => (
        <th
          key={header}
          style={{
            padding: "10px",
            textAlign: "left",
            borderBottom: "1px solid #ddd",
            fontWeight: "bold"
          }}
        >
          {header === "Inbox" ? <GrInbox style={{ fontSize: "20px" }} /> :
           header === "Attachment" ? <GrAttachment style={{ fontSize: "20px" }} /> :
           header}
        </th>
      ))}
    </tr>
  </thead>

  <tbody>
    {filteredCases.length > 0 ? (
      filteredCases.map((caseItem) => (
        <tr
          key={caseItem._id}
          style={{ borderBottom: "1px solid #ddd", cursor: "pointer" }}
        >
          {/* Checkbox for individual case selection */}
          <td>
            <input
              type="checkbox"
              checked={selectedCases.includes(caseItem._id)}
              onChange={() => handleSelectCase(caseItem._id)}
            />
          </td>

          {/* Inbox and Attachment icons */}
          <td><GrInbox style={{ fontSize: "20px" }} /></td>
          <td><GrAttachment style={{ fontSize: "20px" }} /></td>

          {/* Case/Pan column with details and dropdown menu */}
          <td style={{ padding: "10px", textAlign: "left", position: "relative" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  {/* Link to case details */}
                  <Link
                    to={`/case/${caseItem.caseNumber}`}
                    style={{ textDecoration: "none", color: "#004aad", fontSize: "17px" }}
                  >
                    #{caseItem.caseNumber}
                  </Link>

                  {/* Settings icon that toggles dropdown */}
                  <button
                    style={{
                      fontSize: "18px",
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      padding: 0
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleDropdown(caseItem._id);
                    }}
                  >
                    <IoSettingsOutline style={{ color: "#004aad", fontSize: "22px" }} />
                  </button>
                </div>

                {/* Display Pan Color */}
                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <p style={{ margin: 0 }}>Pan Color:</p>
                  <span
                    style={{
                      width: "12px",
                      height: "12px",
                      backgroundColor: caseItem.color ? caseItem.color.toLowerCase() : "#ccc",
                      display: "inline-block",
                      borderRadius: "3px"
                    }}
                  ></span>
                  <span>{caseItem.color || "N/A"}</span>
                </div>

                {/* Rich text editor (Quill) content */}
                <div
                  style={{ fontSize: "14px" }}
                  dangerouslySetInnerHTML={{ __html: caseItem.editorHtml }}
                ></div>
              </div>
            </div>

            {/* Dropdown menu with actions */}
            {dropdownVisible === caseItem._id && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  right: "0",
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  padding: "10px",
                  borderRadius: "5px",
                  zIndex: 1000,
                  width: "150px",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)"
                }}
              >
                <ul style={{ listStyle: "none", padding: "0" }}>
                  <li style={{ padding: "8px 0", cursor: "pointer" }}>
                    <BsFileEarmarkCode /> Close/Invoice
                  </li>
                  <li style={{ padding: "8px 0", cursor: "pointer" }}>
                    <BsPencilFill /> Add Notes
                  </li>
                  <li style={{ padding: "8px 0", cursor: "pointer" }}>
                    <AiOutlineFileAdd /> Upload Files
                  </li>
                </ul>
              </div>
            )}
          </td>

          {/* Other case details columns */}
          <td style={{ padding: "10px", textAlign: "left" }}>
            {caseItem.invoiceNumber || "N/A"}
          </td>
          <td style={{ padding: "10px", textAlign: "left" }}>
            <Link
              to="/TabsWorking"
              style={{ textDecoration: "none", color: "#004aad", fontSize: "16px" }}
            >
              {caseItem.account_holder || "N/A"}
            </Link>
          </td>
          <td style={{ padding: "10px", textAlign: "left" }}>
            {caseItem.provider_name || "N/A"}
          </td>
          <td style={{ padding: "10px", textAlign: "left" }}>
            {caseItem.last_name || "N/A"}
          </td>
          <td style={{ padding: "10px", textAlign: "left" }}>
            {caseItem.start_date ? new Date(caseItem.start_date).toLocaleDateString() : "N/A"}
          </td>
          <td style={{ padding: "10px", textAlign: "left" }}>
            {caseItem.arrive_date ? new Date(caseItem.arrive_date).toLocaleDateString() : "N/A"}
          </td>
          <td style={{ padding: "10px", textAlign: "left" }}>
            {caseItem.date ? new Date(caseItem.date).toLocaleDateString() : "N/A"}
          </td>
        </tr>
      ))
    ) : (
      // Fallback row when no cases are available
      <tr>
        <td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>
          No cases available.
        </td>
      </tr>
    )}
  </tbody>
</table>

             </div>
             <br/>

      
       {/* ✅ Pagination Buttons */}
<div style={{
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '20px',
  width: '95%',
  margin: '0 auto',
  padding: "0px"
}}>
  {/* First page button */}
  <Button
    style={{
      backgroundColor: "#f0f0f0",
      borderColor: "#ced4da",
      flex: 1,
      color: "black",
      marginRight: "0",
      borderRadius: '0'
    }}
    className="mx-0"
  >
    First
  </Button>

  {/* Previous page button */}
  <Button
    style={{
      backgroundColor: "#f0f0f0",
      borderColor: "#ced4da",
      flex: 1,
      color: "black",
      marginRight: "0",
      borderRadius: '0'
    }}
    className="mx-0"
  >
    Previous
  </Button>

  {/* Current page number button */}
  <Button
    style={{
      backgroundColor: "#004aad",
      borderColor: "#004aad",
      flex: 1,
      marginRight: "0",
      borderRadius: '0'
    }}
    className="mx-0"
  >
    1
  </Button>

  {/* Next page button */}
  <Button
    style={{
      backgroundColor: "#f0f0f0",
      borderColor: "#ced4da",
      flex: 1,
      color: "black",
      marginRight: "0",
      borderRadius: '0'
    }}
    className="mx-0"
  >
    Next
  </Button>

  {/* Last page button */}
  <Button
    style={{
      backgroundColor: "#f0f0f0",
      borderColor: "#ced4da",
      flex: 1,
      color: "black",
      marginRight: "0",
      borderRadius: '0'
    }}
    className="mx-0"
  >
    Last
  </Button>
</div>

{/* ✅ Shipment Creation Modal */}
<div className={`modal ${show ? 'show d-block' : 'd-none'}`} tabIndex="-1" role="dialog">
  <div className="modal-dialog modal-dialog-centered" role="document">
    <div className="modal-content">
      {/* Modal Header */}
      <div className="modal-header" style={{ backgroundColor: "#004aad", color: "white" }}>
        <h5 className="modal-title">Create UPS COURIER Shipment</h5>
      </div>

      {/* Modal Body */}
      <div className="modal-body">
        <form>
          {/* Shipper input (read-only / placeholder value shown) */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            padding: '5px 15px',
            borderRadius: '5px',
            flex: 1,
            marginLeft: '-1%'
          }}>
            <label style={labelStyle}>Shipper</label>
            <input
              type="text"
              style={{
                width: '90%',
                borderRadius: '0 7px 7px 0',
                backgroundColor: selectedShipper ? '#ffffff' : '#f0f0f0'
              }}
              value={selectedShipper}
              className="form-control"
              placeholder="Royal Mail"
            />
          </div>

          {/* Tracking number input field */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            padding: '5px 15px',
            borderRadius: '5px',
            flex: 1,
            marginLeft: '-1%'
          }}>
            <label style={{ ...labelStyle, flexShrink: 0 }}>Tracking #</label>
            <input
              type="text"
              style={{ width: '100%', borderRadius: '0 7px 7px 0' }}
              className="form-control"
              placeholder=""
            />
          </div>
          {/* Optional helper text below tracking input */}
          <p style={{ fontSize: "13px", marginLeft: "3%", color: "#9e9e9e" }}>
            Enter a tracking number to create shipment
          </p>

          {/* Shipping cost input field */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            padding: '5px 15px',
            borderRadius: '5px',
            flex: 1,
            marginLeft: '-1%'
          }}>
            <label style={{ ...labelStyle, flexShrink: 0 }}>Shipping Cost</label>
            <input
              type="text"
              style={{ width: '100%', borderRadius: '0 7px 7px 0' }}
              className="form-control"
              placeholder=""
            />
          </div>
        </form>
      </div>

      {/* Modal Footer with actions */}
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCloseModal}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleApply}
          style={{
            padding: '7px',
            backgroundColor: '#004aad',
            color: 'white',
            border: 'none',
            borderRadius: '5px'
          }}
        >
          Create Shipment
        </button>
      </div>
    </div>
  </div>
</div>

{/* ✅ Gray overlay behind modal (only shown when modal is open) */}
{show && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dimmed background
      zIndex: 999
    }}
    onClick={handleCloseModal} // Clicking outside modal closes it
  />
)}

{/* ✅ Filter Modal Component Render
<Filter show={show} handleClose={handleCloseModal} /> */}
    </>
  );
};

export default CreatShipment;
